import { z } from 'zod'
import { CitationMetadataSchema } from './citation-metadata-schema'

// Mirrors the backend `CaseReviewEnum` (paxton_app/citator/enums.py).
export enum CaseReviewEnum {
  overturned = 'overturned',
  overturned_in_part = 'overturned_in_part',
  vacated = 'vacated',
  overturning_recognized = 'overturning_recognized',
  refined = 'refined',
  affirmed = 'affirmed',
  cited_favorably = 'cited_favorably',
  questioned = 'questioned',
  neutrally_cited = 'neutrally_cited',
  distinguished = 'distinguished',
  undermined = 'undermined',
  not_applicable = 'not_applicable',
}

/**
 * Citing-case variant of `CitationMetadata` (mirrors the BE's `CitingCaseWithReview`).
 * `review_label` is parsed as a string so new backend review values don't break the whole
 * citing-cases response; display remains gated by `isDisplayableCaseReview`.
 */
export const CitingCaseSchema = CitationMetadataSchema.extend({
  review_label: z.string().nullable().optional(),
  explanation: z.string().nullable().optional(),
})
export type CitingCase = z.infer<typeof CitingCaseSchema>

export const CitatorCitingCasesResponseSchema = z.array(CitingCaseSchema)
export type CitatorCitingCasesResponse = z.infer<typeof CitatorCitingCasesResponseSchema>

/** Review values that produce a visible badge (only negative or cautionary indicators for now) */
export const DISPLAYABLE_CASE_REVIEWS = [
  // hard-negative
  CaseReviewEnum.overturned,
  CaseReviewEnum.overturned_in_part,
  CaseReviewEnum.vacated,
  CaseReviewEnum.overturning_recognized,
  // soft-negative
  CaseReviewEnum.refined,
  CaseReviewEnum.questioned,
  CaseReviewEnum.distinguished,
  // indirect
  CaseReviewEnum.undermined,
  // positive (`affirmed`) intentionally deferred to follow-on PR
] as const

export type DisplayableCaseReview = (typeof DISPLAYABLE_CASE_REVIEWS)[number]

export function isDisplayableCaseReview(review: string | null | undefined): review is DisplayableCaseReview {
  return review != null && (DISPLAYABLE_CASE_REVIEWS as readonly string[]).includes(review)
}
